import React, { Component } from 'react';
import { FlatButton, FontIcon, RaisedButton, TextField } from 'material-ui';
import Dropzone from '../../extra/dropzone/dropzone';
import injectSheet from 'react-jss';
import moment from 'moment';
import { findDOMNode } from 'react-dom';

const styles = {
  uploadArea: { border: '4px dashed rgb(239, 239, 239)', padding: '12px 8px', clear: 'both', minHeight: '150px' },
};

class UploadBox extends Component {

  constructor(props) {
    super(props);
    this.state = {
      filesUploading: [],
      filesUploaded: [],
    };
  }
  onUploadClick = () => {
    if (findDOMNode(this.refs.fileInput).value) findDOMNode(this.refs.fileInput).value = null;
    findDOMNode(this.refs.fileInput).click();
  };
  onDropFiles = e => {
    e.preventDefault();

    this.setState({
      isDragActive: false,
    });

    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    this.props.addFiles([...this.state.filesUploaded, ...files]);
  };
  render() {
    const {
      classes,
      deadlineDate,
      addFiles,
      filesUploaded,
      message,
      onMessageChange,
      removeFile,
      sendRates,
      btnLabel,
    } = this.props;
    return (
      <div>
        {
          Boolean(filesUploaded && filesUploaded.length) && (
            <div style={{ marginTop: '2em', width: '575px', textAlign: 'left' }}>
              {
                filesUploaded.map((file, i) => (
                  <div key={i} className="flex-tc-sb" style={{ borderBottom: '1px solid #e0e0e0' }}>
                    {file.name}
                    <FontIcon
                      color="#ff4081"
                      style={{ cursor: 'pointer' }}
                      onClick={removeFile(i)}
                      className="tc-icon-delete2"
                    />
                  </div>
                ))
              }
              <div>
                <FlatButton
                  icon={<FontIcon className="tc-icon-add"/>}
                  secondary
                  label="ADD MORE FILES"
                  onClick={this.onUploadClick}
                />
              </div>
            </div>
          )
        }
        <input style={{ display: 'none' }} type="file" multiple ref="fileInput" onChange={this.onDropFiles} />
        <div style={{ marginTop: '2em' }}>
          {
            filesUploaded.length
              ? (
                <div
                  style={{
                    padding: '8px 12px',
                    overflow: 'auto',
                    minHeight: '80px',
                    border: '1px solid #00BCD4',
                    width: '575px',
                    backgroundColor: '#fff',
                  }}
                >
                  <TextField
                    id="messagebox"
                    hintStyle={{ fontSize: '14px' }}
                    hintText="Optional message text to be sent with your rates..."
                    underlineShow={false}
                    onChange={onMessageChange}
                    style={{ width: 'calc(100% - 24px)' }}
                    multiLine
                    rowsMax={8}
                    value={message}
                  />
                </div>
              )
              : (
                <div className={classes.uploadArea}>
                  <Dropzone
                    style={{ display: 'flex', alignItems: 'center', fontSize: '16px', color: 'rgba(0, 0, 0, 0.44)' }}
                    onDrop={addFiles}
                  >
                    <FontIcon className="tc-icon-add" color="#bfbfbf" style={{ fontSize: '100px', marginRight: '16px' }} />
                    Attach files by dragging & dropping or&nbsp;<span style={{ color: '#00b3cf', cursor: 'pointer' }}>selecting them</span>
                  </Dropzone>
                </div>
              )
          }
        </div>
        {
          Boolean(filesUploaded.length) && (
            <div style={{ marginTop: '1em', width: '575px', textAlign: 'right' }}>
              <RaisedButton
                secondary
                label={btnLabel}
                onClick={sendRates}
              />
            </div>
          )
        }
      </div>
    );
  }
}

UploadBox.propTypes = {
  classes: React.PropTypes.object,
  addFiles: React.PropTypes.func,
  deadlineDate: React.PropTypes.string,
  filesUploaded: React.PropTypes.array,
  message: React.PropTypes.string,
  onMessageChange: React.PropTypes.func,
  removeFile: React.PropTypes.func,
  sendRates: React.PropTypes.func,
  btnLabel: React.PropTypes.string,
};

export default injectSheet(styles)(UploadBox);



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/request/upload-box.jsx